<div class="wrapper">
    <img src="assets/images/currencies/{{currentTheme}}/{{currency || 'EMPTY'}}.svg" [alt]="currency">
</div>
